var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolanaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 22,
    viewBox: "0 0 152 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2439",
    "data-name": "Rectangle 2439",
    width: 152,
    height: 22,
    transform: "translate(0.4 0.354)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.084,
    y1: 1.024,
    x2: 0.905,
    y2: -0.011,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43b4ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28e0b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19fb9b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dark-horizontal.c3a5eb36",
    transform: "translate(-0.4 -0.354)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32183",
    "data-name": "Path 32183",
    d: "M27.008,17.9,22.816,22.4a.97.97,0,0,1-.71.31H2.238a.487.487,0,0,1-.357-.818l4.187-4.494a.97.97,0,0,1,.71-.31H26.646a.485.485,0,0,1,.362.818ZM22.816,8.851a.979.979,0,0,0-.71-.31H2.238a.487.487,0,0,0-.357.818l4.187,4.5a.979.979,0,0,0,.71.31H26.646A.487.487,0,0,0,27,13.347ZM2.238,5.622H22.107a.97.97,0,0,0,.71-.31L27.008.818A.485.485,0,0,0,26.646,0H6.777a.97.97,0,0,0-.71.31L1.881,4.8a.487.487,0,0,0,.357.818Z",
    transform: "translate(-1.337 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32184",
    "data-name": "Path 32184",
    d: "M165.178,18h-10.63V14.5H167.94V11H154.512A3.494,3.494,0,0,0,151,14.475v3.548a3.494,3.494,0,0,0,3.512,3.479h10.644V25h-13.9v3.5h13.925a3.494,3.494,0,0,0,3.512-3.475V21.481A3.494,3.494,0,0,0,165.178,18Z",
    transform: "translate(-115.284 -8.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32185",
    "data-name": "Path 32185",
    d: "M252.192,11h-10.67A3.494,3.494,0,0,0,238,14.474V25.028a3.493,3.493,0,0,0,3.522,3.475h10.67a3.494,3.494,0,0,0,3.512-3.475V14.474A3.494,3.494,0,0,0,252.192,11Zm-.026,14H241.548V14.5h10.613Z",
    transform: "translate(-181.705 -8.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32186",
    "data-name": "Path 32186",
    d: "M411.07,11H400.662a3.494,3.494,0,0,0-3.512,3.475V28.5H400.7v-5.75h10.36V28.5h3.548V14.474A3.494,3.494,0,0,0,411.07,11Zm-.026,8.253h-10.36V14.5h10.36Z",
    transform: "translate(-303.211 -8.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32187",
    "data-name": "Path 32187",
    d: "M586.22,11H575.813a3.494,3.494,0,0,0-3.513,3.475V28.5h3.548v-5.75h10.336V28.5h3.548V14.475A3.494,3.494,0,0,0,586.22,11Zm-.036,8.253h-10.36V14.5h10.36Z",
    transform: "translate(-436.933 -8.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32188",
    "data-name": "Path 32188",
    d: "M498.329,25H496.91l-5.074-12.536A2.339,2.339,0,0,0,489.67,11h-3.148a2.33,2.33,0,0,0-2.342,2.318V28.5h3.548v-14h1.419l5.071,12.536a2.347,2.347,0,0,0,2.176,1.457h3.148a2.33,2.33,0,0,0,2.342-2.318V11h-3.555Z",
    transform: "translate(-369.656 -8.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32189",
    "data-name": "Path 32189",
    d: "M329.648,11H326.1V25.029a3.493,3.493,0,0,0,3.524,3.475h10.644V25h-10.62Z",
    transform: "translate(-248.967 -8.398)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaLogo);
export default __webpack_public_path__ + "static/media/solana-logo.4e35aea693caf38c65b8e87b5aaa61fe.svg";
export { ForwardRef as ReactComponent };